var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTree = function SvgTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tree_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#083A71"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.11 22.314a1.962 1.962 0 0 0-.11-.069v-2.724a.97.97 0 0 0 0-.042v-2.361l5.447-2.724a1 1 0 1 0-.895-1.789L17 14.882v-3.383a1 1 0 1 0-2 0v4.98a.97.97 0 0 0 0 .042v1.36l-4.553-2.276a1 1 0 1 0-.895 1.789L15 20.118v2.128a2.014 2.014 0 0 0-.11.067l-.015.01A6.999 6.999 0 0 1 4.29 14.336 7 7 0 0 1 8.11 10.13c.43-.215.77-.574.965-1.013l.008-.018a7.5 7.5 0 0 1 13.831 0l.008.018a2.075 2.075 0 0 0 1.005 1.033 7 7 0 1 1-6.803 12.173l-.014-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 2.502A9.5 9.5 0 0 0 7.246 8.31a.075.075 0 0 1-.025.03 9 9 0 1 0 7.778 16.227V29.5a1 1 0 1 0 2 0v-4.933a9.002 9.002 0 0 0 11.923-3.639A9 9 0 0 0 24.779 8.34a.075.075 0 0 1-.026-.028A9.5 9.5 0 0 0 16 2.5Zm1 19.743c.037.022.074.045.11.069l.015.009a7 7 0 1 0 6.763-12.193 2.075 2.075 0 0 1-.965-1.013l-.008-.018a7.5 7.5 0 0 0-13.83 0l-.009.018a2.075 2.075 0 0 1-1.005 1.033 7 7 0 1 0 6.803 12.173l.014-.01c.037-.023.074-.046.111-.067v-2.128l-5.447-2.724a1 1 0 1 1 .895-1.789L15 17.881v-1.36a.97.97 0 0 1 0-.042V11.5a1 1 0 1 1 2 0v3.383l4.552-2.277a1 1 0 1 1 .895 1.789L17 17.117v2.362a.97.97 0 0 1 0 .042v2.724Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.567v-4.449l-5.447-2.724a1 1 0 1 1 .894-1.788L15 17.882v-1.36a.97.97 0 0 1 0-.042V11.5a1 1 0 1 1 2 0v3.382l4.553-2.276a1 1 0 1 1 .894 1.788L17 17.118v2.362a.97.97 0 0 1 0 .042V29.5a1 1 0 0 1-2 0v-4.933Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tree_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgTree;